"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelLoader = void 0;
const three_1 = require("three");
const config_1 = require("../config");
const modelFormat_1 = require("../enums/modelFormat");
const modelType_1 = require("../enums/modelType");
const gltf_1 = require("./gltf");
const Image360Loader_1 = require("./Image360Loader");
const NexusLoader_1 = require("./NexusLoader");
class ModelLoader {
    constructor(modelType, modelFormat) {
        this.storageApiMainUrl = config_1.config.backend.storagePath;
        this.modelType = modelType;
        this.modelFormat = modelFormat;
    }
    load(url, webgl, tokenProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            const storageApiUrl = this.storageApiMainUrl + url;
            this.startLoadingManager();
            if (!this.loadingManager) {
                throw new Error("Loading manager is undefined");
            }
            if (this.modelType === modelType_1.ModelType.MODEL_TYPE_IMAGE_360) {
                const img = new Image360Loader_1.Image360Loader();
                return img.load(storageApiUrl, this.loadingManager, tokenProvider);
            }
            else {
                switch (this.modelFormat) {
                    case modelFormat_1.ModelFormat.MODEL_FORMAT_GLTF:
                        const gltf = new gltf_1.Gltf();
                        return gltf.load(storageApiUrl, this.loadingManager, tokenProvider);
                    case modelFormat_1.ModelFormat.MODEL_FORMAT_NEXUS:
                        const nxz = new NexusLoader_1.NexusLoader();
                        return nxz.load(webgl, storageApiUrl, this.loadingManager, tokenProvider);
                    default: throw new Error("Trying to load unsupported model format: " + this.modelFormat);
                }
            }
        });
    }
    startLoadingManager() {
        this.loadingManager = new three_1.LoadingManager();
        this.loadingManager.onStart = function (url, itemsLoaded, itemsTotal) {
            // console.log( 'Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
        };
        this.loadingManager.onLoad = function () {
            console.log('Loading complete!');
        };
        this.loadingManager.onProgress = function (url, itemsLoaded, itemsTotal) {
            // console.log( 'Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
        };
        this.loadingManager.onError = function (url) {
            console.log('There was an error loading ' + url);
        };
    }
}
exports.ModelLoader = ModelLoader;
